import React from 'react'

const ExchangeRateRow = ({ value, currency, id }) => {

    return (
        <tr key={id} >
            <td className='align-middle'><b>{currency?.iso} {value?.toFixed(2)} = $ 1</b></td>
        </tr>
    )
}

export default ExchangeRateRow;